<template>
	<div class="node-name">
		<v-icon v-if="icon" class="icon" small>{{ icon }}</v-icon>
		{{ name }}
	</div>
</template>

<script>
import * as k4util from "@/utils/k4util";

export default {
	props: {
		node: {
			type: Object,
			required: true,
		},

		showIcon: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		isDateTime() {
			return k4util.isTypeTime(this.node) || k4util.isTypeDate(this.node);
		},

		name() {
			return this.node.readableName;
		},

		icon() {
			return this.showIcon && k4util.deviceFAIcon(this.node);
		},
	},
};
</script>
